/**
 * The name a file is known by.
 *
 * A corrected delivery of "ch1.wav" is stored as "ch1 (v2).wav" - storage
 * names must stay unique - but it is still ch1.wav: the version belongs on the
 * version tag, never in the name. Anything that PRINTS a file's name for a
 * person goes through here; anything that FINDS the file keeps using
 * `audio_filename` (server: core/versions.shown_names).
 */
export function shownFile(c: { audio_filename?: string | null; shown_filename?: string | null } | undefined | null): string {
  return c?.shown_filename || c?.audio_filename || "";
}

/** ...without its extension, as the report's file switcher lists them. */
export const shownStem = (c: Parameters<typeof shownFile>[0]) => shownFile(c).replace(/\.[^/.]+$/, "");
